import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  private auth = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const requiredPermissions = route.data?.['permissions'] as
      | string[]
      | undefined;
    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }

    const hasAll = requiredPermissions.every((p) => this.auth.hasPermission(p));
    if (!hasAll) {
      this.router.navigate(['/app/dashboard']);
      return false;
    }
    return true;
  }
}
